<template>
	<div>
		<AppHeader title="지점 예약 내역" is-history />

		<AppContent>
			<ReservationList />
		</AppContent>

		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppContent from '@/components/common/AppContent';
import AppFooter from '@/components/common/AppFooter';
import ReservationList from '@/components/Reservation/ReservationList';

export default {
	components: {
		AppHeader,
		AppContent,
		AppFooter,
		ReservationList,
	},
};
</script>
